<template>
  <Teleport to="#supplement-name-container">
    <div v-if="isEditing" class="is-flex is-align-items-center">
      <input
        ref="inputEl"
        v-model="editValue"
        type="text"
        class="supplement-name-input"
        placeholder="Supplement Label Name"
        data-test-id="supplement-name-input"
        autocomplete="off"
        @keydown.enter.prevent="commitEdit"
        @keydown.escape.prevent="cancelEdit"
        @blur="handleBlur"
      />
      <button
        ref="cancelBtn"
        type="button"
        class="button is-light is-small ml-2"
        @click="cancelEdit"
      >
        Cancel
      </button>
    </div>

    <div v-else class="is-flex is-align-items-center">
      <h1
        class="title supplement-label-name mb-0 is-selectable"
        :data-hide-name="store.hideName"
        style="cursor: pointer; border-bottom: 1px dashed #dbdbdb"
        title="Click to rename"
        @click="startEdit"
      >
        {{ store.name }}
      </h1>
    </div>
  </Teleport>
</template>

<script setup>
  import { ref, nextTick, inject } from "vue";
  import { useSupplementLabelStore } from "../stores/supplement-label-store";

  const store = useSupplementLabelStore();
  const save = inject("triggerSave");

  const isEditing = ref(false);
  const editValue = ref("");
  const inputEl = ref(null);
  const cancelBtn = ref(null);

  function startEdit() {
    editValue.value = store.name;
    isEditing.value = true;
    nextTick(() => {
      inputEl.value?.focus();
      inputEl.value?.select();
    });
  }

  function commitEdit() {
    const trimmed = editValue.value.trim();
    if (!trimmed) {
      cancelEdit();
      return;
    }
    store.name = trimmed;
    document.title = trimmed;
    isEditing.value = false;
    save();
  }

  function cancelEdit() {
    editValue.value = store.name;
    isEditing.value = false;
  }

  function handleBlur(e) {
    if (e.relatedTarget === cancelBtn.value) {
      return;
    }
    commitEdit();
  }
</script>

<style lang="scss" scoped>
  .supplement-name-input {
    font-family: inherit;
    font-size: 2rem;
    font-weight: 600;
    line-height: 1.125;
    color: hsl(0, 0%, 21%);
    max-width: 40ch;
    width: 100%;
    padding: 0;
    margin: 0;
    border: none;
    border-bottom: 1px dashed transparent;
    border-radius: 0;
    background: transparent;
    outline: 2px solid hsl(217, 71%, 53%);
    outline-offset: 3px;

    &::placeholder {
      color: hsl(0, 0%, 72%);
    }
  }
</style>
